import { graphql } from "gatsby";
import React, { useRef } from "react";

import Layout from "../components/layout";
import Newsletter from "../components/newsletter";
import Seo from "../components/seo";
import Hero from "../components/shared/hero";
import TextPageComponent from "../components/text-page/textPageComponent";
import { ThemeContext } from "../context/ThemeContext";
import { useBannerDetails } from "../hooks/useBannerManager";
import heroImgPlaceholder from "../images/volunteer/hero-img.png";
import { formatHeroBackgroundOptions } from "../utils/formatContent";

const TextInfoPageTemplate = ({ data, location }) => {
  const page = data?.page;
  const { acfLandingPage, globalConfig } = page;
  const schoolTrips = data?.schoolTrips?.nodes ?? [];

  const showSchools = acfLandingPage?.genSchoolTripsShow ?? "";
  const schoolTitle = acfLandingPage?.genSchoolTripsSectionTitle ?? "";

  const heroBackgroundConfig = formatHeroBackgroundOptions(globalConfig);

  const wpTemplate =
    page && data && page.template && page.template.templateName
      ? page.template.templateName.toLowerCase()
      : "default";

  const heroBackgroundImage = heroBackgroundConfig?.image?.desktop;
  const heroBackgroundVideo = heroBackgroundConfig?.video?.desktop;
  const heroBackgroundImageMobile = heroBackgroundConfig?.image?.mobile;

  const headerIcons = (acfLandingPage && acfLandingPage?.genHeaderIcons) ?? [];
  const groupProgramSourceType =
    acfLandingPage?.genProgramListSourceType === "group_programs";

  const heroNavLinks = headerIcons?.map((icon, idx) => {
    return {
      imgPath: "location-icon.svg",
      toPage: "#",
      text: `Something something-${idx}`
    };
  });

  //filters set in the landing page options

  // console.debug("debug page :: TextInfoPageTemplate", {
  //   wpTemplate: wpTemplate,
  //   title: page?.title,
  //   template: page?.template?.templateName?.toLowerCase(),
  //   slug: page?.slug
  // });

  const isHomepage = false;

  const heroOverlayTitle = acfLandingPage?.genHeaderOverlayTitle ?? "";

  const heroRef = useRef(null);

  const textPageConfig = {
    page,
    genericDetails: data?.genericDetails,
    defaultBlogPosts: null,
    schoolTrips,
    showSchools,
    schoolTitle
  };

  let applyNow = "/application-form/";
  let enquireNow = "/enquiry-form/";

  if (groupProgramSourceType === true) {
    applyNow = `#`;
    enquireNow = `/enquiry-form/?type=group_enquiry`;
  }

  const banner = useBannerDetails(page?.slug);

  const enquireUKCardDetails = {
    footerTitle: banner?.title ?? "",
    footerSubtitle: banner?.desc ?? "",
    footerImage: banner?.image || null,
    cardBookDesc: "",
    enquireNowCtaTitle: "Enquire",
    footerCtaTitle: "Apply",
    footerSubtitleClass: "text-sm dark:text-white text-black-lighter",
    contentContainerClass: "sm:w-2/5",
    cardBookDescSpanClass:
      "text-xs font-semibold text-left sm:font-normal dark:text-white text-generic-text",
    applicationFormLink: applyNow,
    enquireNowLink: enquireNow,
    enquireBtn: true,
    allowCookieControl: false,
    displayCloseButton: false,
    footerPromoCookieName: [
      "isPromoStickyFooterShow",
      page?.id ?? page?.slug
    ].join(""),
    heroRef: heroRef
  };

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page.title}
          containerClass={isHomepage ? "w-full mx-auto" : "w-full mx-auto"}
          enquireNow={enquireNow}
          applyNow={applyNow}
          brandingOpts={{ ...theme }}
          updateOnScroll={!groupProgramSourceType === true}
          showGrantsBanner={!groupProgramSourceType === true}
          stickyFooterDetails={
            groupProgramSourceType === true ? {} : enquireUKCardDetails
          }
        >
          <div ref={heroRef}>
            <Hero
              heroHeadLine={heroOverlayTitle}
              heroImg={heroBackgroundImage}
              navLinks={heroNavLinks ?? ""}
              videoId={heroBackgroundVideo}
              heroImageMobile={heroBackgroundImageMobile}
            />
          </div>

          <TextPageComponent {...textPageConfig} theme={theme} />

          <Newsletter />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query ($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...WpPageFragment
    }

    genericDetails: wp {
      globalProgramConfig: gviConfigSettings {
        acfTermsAndConditions {
          gblTermsAndConditions
        }
        acfKeyMessagingIcons {
          ...AcfKeymessagingiconsFragment
        }
        acfGenericGlobalConfig {
          ...ProgramFeesFragment
          ...StickyWidgetFragment
          ...OpenDayGalleryFragment
        }
      }
    }

    schoolTrips: allWpSchoolTrip {
      ...WpSchoolTripFragment
    }
  }
`;

export default TextInfoPageTemplate;
